import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StateState } from '../reducers';

export const selectStateState = createFeatureSelector<StateState>('state');

export const selectStateLoading = createSelector(
  selectStateState,
  (state: StateState) => state.loading
);

export const selectStateEditMode = createSelector(
  selectStateState,
  (state: StateState) => state.editMode
);

export const selectState = createSelector(
  selectStateState,
  (state: StateState) => state.state
);

export const selectStateList = createSelector(
  selectStateState,
  (state: StateState) => state.stateList
);

export const selectStateForm = createSelector(
  selectStateState,
  (state: StateState) => state.stateForm
);

export const selectStateError = createSelector(
  selectStateState,
  (state: StateState) => state.error
);